const grantTypes = {
    password : 'password',
    refresh_token: 'refresh_token'
}

export default grantTypes